<template>
  <v-container class="pa-0 mb-12">
    <div class="d-flex my-18px">
      <h2 class="noselect">Šablóny</h2>
      <v-btn :ripple="false" class="btn-primary link ml-auto mr-n3"
        >Všetky šablóny</v-btn
      >
    </div>
    <div class="dash-container-body">
      <v-row no-gutters class="mx-n4">
        <v-col
          v-for="(item, index) in data"
          :key="index"
          xl="3"
          lg="3"
          md="3"
          class="px-4"
        >
          <v-card class="pa-5 card-item-dark">
            <text-group
              utext="Názov šablóny"
              :btext="item.nazov"
              large
            ></text-group>
            <text-group
              class="mt-12px"
              utext="Popis"
              :btext="item.popis"
              smallHeader
              :btextBold="false"
            ></text-group>
            <v-divider class="my-8px"></v-divider>
            <v-btn icon small tile outlined class="btn-secondary">
              <v-icon dark size="18"> mdi-reply </v-icon>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import TextGroup from '../basic/TextGroup';
export default {
  components: { TextGroup },
  data() {
    return {
      data: [
        {
          nazov: 'Lorem ipsum',
          popis:
            'In congue neque felis, quis gravida tellus elementum sit amet.',
        },
        {
          nazov: 'Fusce quis',
          popis:
            'Nulla facilisi. Aliquam euismod lectus non quam viverra venenatis.',
        },
        {
          nazov: 'Proin sed',
          popis:
            'In congue neque felis, quis gravida tellus elementum sit amet.',
        },
        {
          nazov: 'Donec vitae',
          popis: 'Aenean elementum lobortis dolor, ut varius erat accumsan et.',
        },
      ],
    };
  },
};
</script>
<style lang="sass" scoped></style>
